export const Check = () => {
    return (
        <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99974 10.1715L16.1917 0.978516L17.6067 2.39252L6.99974 12.9995L0.635742 6.63552L2.04974 5.22152L6.99974 10.1715Z" fill="#06D01A"/>
        </svg>

    )
}

export const Check2 = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M14.2136 5.09283L6.50288 12.8036C6.24101 13.0654 5.8165 13.0654 5.55462 12.8035L1.19637 8.44529C0.934542 8.18346 0.934542 7.75891 1.19637 7.49708L2.14459 6.54886C2.40646 6.28703 2.83101 6.28703 3.09284 6.54886L6.02875 9.48477L12.3172 3.1964C12.579 2.93453 13.0036 2.93453 13.2654 3.1964L14.2136 4.14462C14.4755 4.40645 14.4755 4.831 14.2136 5.09283Z" fill="currentColor"/>
        </svg>
    )
}